import { ref } from 'vue';
import { randomPalette } from '@sulje/brand';

/**
 * One random Puida palette per page load, shared by every separator and the
 * footer — as puida.com's `scripts/separators.ts` does. A palette per
 * component would give each wave a different, unrelated colour.
 */
export const pagePalette = randomPalette();

/**
 * The colour the footer's separator grows out of, when a page knows better
 * than its route: a themed project's background is the project's, not
 * Sulje's, and the footer sits outside the themed element.
 */
export const footerFrom = ref<string | null>(null);
